import CompanyActionTypes from "./company.types";

/** ***************** GET COMPANY LIST START *********************** */
export const getCompanyListStart = (getData: any) => ({
  type: CompanyActionTypes.GET_COMPANY_LIST_START,
  payload: getData,
});

export const getCompanyListSuccess = (successData: any) => ({
  type: CompanyActionTypes.GET_COMPANY_LIST_SUCCESS,
  payload: successData,
});

export const getCompanyListFailure = (failureData: any) => ({
  type: CompanyActionTypes.GET_COMPANY_LIST_FAILURE,
  payload: failureData,
});

export const getCompanyListResponseResetStart = () => ({
  type: CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_RESET,
});

export const getCompanyListResponseChanged = () => ({
  type: CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_CHANGED,
});

/** ***************** GET COMPANY LIST END *********************** */

/** ***************** ADD COMPANY DETAILS START *********************** */
export const addCompanyDetailsStart = (addData: any) => ({
  type: CompanyActionTypes.ADD_COMPANY_DETAILS_START,
  payload: addData,
});

export const addCompanyDetailsSuccess = (successData: any) => ({
  type: CompanyActionTypes.ADD_COMPANY_DETAILS_SUCCESS,
  payload: successData,
});

export const addCompanyDetailsFailure = (failureData: any) => ({
  type: CompanyActionTypes.ADD_COMPANY_DETAILS_FAILURE,
  payload: failureData,
});

export const addCompanyDetailsResponseResetStart = () => ({
  type: CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_RESET,
});

export const addCompanyDetailsResponseChanged = () => ({
  type: CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD COMPANY DETAILS END *********************** */

/** ***************** UPDATE COMPANY DETAILS START *********************** */
export const updateCompanyDetailsStart = (updateData: any) => ({
  type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_START,
  payload: updateData,
});

export const updateCompanyDetailsSuccess = (successData: any) => ({
  type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_SUCCESS,
  payload: successData,
});

export const updateCompanyDetailsFailure = (failureData: any) => ({
  type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_FAILURE,
  payload: failureData,
});

export const updateCompanyDetailsResponseResetStart = () => ({
  type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const updateCompanyDetailsResponseChanged = () => ({
  type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE COMPANY DETAILS END *********************** */

/** ***************** DELETE COMPANY DETAILS START *********************** */
export const deleteCompanyDetailsStart = (deleteData: any) => ({
  type: CompanyActionTypes.DELETE_COMPANY_DETAILS_START,
  payload: deleteData,
});

export const deleteCompanyDetailsSuccess = (successData: any) => ({
  type: CompanyActionTypes.DELETE_COMPANY_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteCompanyDetailsFailure = (failureData: any) => ({
  type: CompanyActionTypes.DELETE_COMPANY_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteCompanyDetailsResponseResetStart = () => ({
  type: CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const deleteCompanyDetailsResponseChanged = () => ({
  type: CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE COMPANY DETAILS END *********************** */

/** ***************** FETCH COMPANY DETAILS START *********************** */
export const fetchCompanyDetailsStart = (fetchData: any) => ({
  type: CompanyActionTypes.FETCH_COMPANY_DETAILS_START,
  payload: fetchData,
});

export const fetchCompanyDetailsSuccess = (successData: any) => ({
  type: CompanyActionTypes.FETCH_COMPANY_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchCompanyDetailsFailure = (failureData: any) => ({
  type: CompanyActionTypes.FETCH_COMPANY_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchCompanyDetailsResponseResetStart = () => ({
  type: CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_RESET,
});

export const fetchCompanyDetailsResponseChanged = () => ({
  type: CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH COMPANY DETAILS END *********************** */

/** ***************** ADD INSTANCE DETAILS START *********************** */
export const addInstanceDetailsStart = (addData: any) => ({
  type: CompanyActionTypes.ADD_INSTANCE_DETAILS_START,
  payload: addData,
});

export const addInstanceDetailsSuccess = (successData: any) => ({
  type: CompanyActionTypes.ADD_INSTANCE_DETAILS_SUCCESS,
  payload: successData,
});

export const addInstanceDetailsFailure = (failureData: any) => ({
  type: CompanyActionTypes.ADD_INSTANCE_DETAILS_FAILURE,
  payload: failureData,
});

export const addInstanceDetailsResponseResetStart = () => ({
  type: CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_RESET,
});

export const addInstanceDetailsResponseChanged = () => ({
  type: CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_CHANGED,
});
/** ************** ADD INSTANCE DETAILS END ********************* */
